// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_PlansResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_PlansResponse — list of subscription plans.
 * Used by GET /subscriptions/plans, plan create/update endpoints and the
 * franqueado storefront GET /subscriptions/available-plans.
 */
import type { Subscriptions_PlanRow } from './Subscriptions_PlanRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Subscriptions_PlansResponseDados {
rows: Subscriptions_PlanRow[]
empty_reason: string
}

export type Subscriptions_PlansResponse = ApiResponse<Subscriptions_PlansResponseDados>;

registerResponseContract('Subscriptions_PlansResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:                   { type: 'number',  required: true },
      name:                 { type: 'string',  required: true },
      price_cents:          { type: 'number',  required: false },
      cycle:                { type: 'string',  required: true },
      monthly_credit_grant: { type: 'number',  required: true },
      active:               { type: 'number',  required: true },
      currency:             { type: 'string',  required: false },
      provider_code:        { type: 'string',  required: false },
      provider_price_ref:   { type: 'string',  required: false },
      stripe_price_id:      { type: 'string',  required: false },
      superseded_by:        { type: 'number',  required: false },
      created_at:           { type: 'string',  required: false },
      updated_at:           { type: 'string',  required: false },
      countries:            { type: 'array',   required: false },
    },
  },
  empty_reason: { type: 'string',  required: false },
})
